module.exports = __webpack_public_path__ + "img/182-niue.e5e72405.svg";